import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type Lang = 'en' | 'hi';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private readonly STORAGE_KEY = 'lang';

  private _currentLang = signal<Lang>(
    (sessionStorage.getItem(this.STORAGE_KEY) as Lang) ?? 'hi'
  );

  language$ = new BehaviorSubject<Lang>(this._currentLang());

  get currentLang(): Lang {
    return this._currentLang();
  }

  setLanguage(lang: Lang) {

    // 1️⃣ Persist FIRST
    sessionStorage.setItem(this.STORAGE_KEY, lang);

    // 2️⃣ Update runtime state
    this._currentLang.set(lang);
    this.language$.next(lang);

    // 3️⃣ Reload AFTER state is stable
    setTimeout(() => {
      window.location.reload();
    }, 0);
  }
}
